import React, { useState } from "react"
import { Link } from "gatsby"
import { useSpring } from "react-spring"

import logo from "../../images/logo.svg"
import Menu from "../menu/menu"
import Button from "../button/button"
import Hamburger from "react-hamburgers"

import "./header.sass"
import "./menu-button.sass"

const REGISTER = "https://theconcord.ca/Register/TheConcord.html"

const Header = props => {
  const [isNavOpen, setNavOpen] = useState(false)
  const navAnimation = useSpring({
    transform: isNavOpen ? "translate3d(0,0,0)" : "translate3d(100%,0,0)",
  })
  const isPartiallyActive = ({ isPartiallyCurrent }) => {
    return isPartiallyCurrent ? { className: "nav-active" } : null
  }

  return (
    <header>
      <div className="navbar">
        <Link to="/" className="logo">
          <img src={logo} alt="logo" />
        </Link>
        <nav className="navbar-items">
          <ul>
            <li>
              <Link to="/" activeClassName="nav-active">
                overview
              </Link>
            </li>
            <li>
              <Link to="/amenities/" activeClassName="nav-active">
                amenities
              </Link>
            </li>
            <li>
              <Link to="/floorplans/" activeClassName="nav-active">
                floorplans
              </Link>
            </li>
            <li>
              <Link to="/blog/" getProps={isPartiallyActive} {...props}>
                news
              </Link>
            </li>
            <li>
              <Link to="/interiors/" activeClassName="nav-active">
                interiors
              </Link>
            </li>
            <li>
              <Button cssClass="btn btn-secondary" href={REGISTER}>
                register
              </Button>
            </li>
          </ul>
        </nav>
        <div className="menu-container">
          <div className="menu">menu</div>
          <div className="menu-button">
            <Hamburger
              type="spin"
              onClick={() => setNavOpen(!isNavOpen)}
              active={isNavOpen}
            />
          </div>
        </div>
      </div>
      <Menu style={navAnimation} />
    </header>
  )
}

export default Header
